import React from "react";
import { Link } from "react-router-dom";
import SectionHeader from "../SectionHeader";

const partners = [
  { name: "SOV", logo: "/images/partnerships/SOV.jpg", url: "https://www.specialolympics.com.au/" },
  { name: "Atalgo", logo: "/images/partnerships/atalgo.jpg", url: null },
  { name: "Best Chance", logo: "/images/partnerships/bestchance.jpg", url: "https://www.bestchance.org.au/" },
  { name: "Carevo", logo: "/images/partnerships/carevo.jpg", url: "https://carevo.com.au/" },
  { name: "Envaedha", logo: "/images/partnerships/envaedha.jpg", url: "https://envaedha.com.au" },
  { name: "Flourish", logo: "/images/partnerships/Flourish.jpg", url: "https://www.flourishaustralia.org.au/" },
  { name: "Social Threads", logo: "/images/partnerships/social-threads.jpg", url: "https://www.socialthreads.au/" },
  { name: "Soulful Learning", logo: "/images/partnerships/soulful-learning.jpg", url: "https://soulful-learning.com.au/" },
];

const Partners = () => {
  return (
    <div className="w-full px-6 md:px-16">
      <div className="max-w-[1280px] mx-auto flex flex-col gap-10">
        <SectionHeader
          title="Our Partners"
          description="Organisations we proudly work with"
        />

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-5">
          {partners.map((partner) => {
            const card = (
              <div
                className={`flex flex-col items-center justify-center gap-3 bg-white rounded-[20px] p-5 border border-[#EEF0F6] transition-shadow duration-300 ${partner.url ? "hover:shadow-md cursor-pointer" : ""}`}
                style={{ boxShadow: "0px 2px 10px rgba(0,0,0,0.05)" }}
              >
                <div className="w-full h-[80px] flex items-center justify-center">
                  <img
                    src={process.env.PUBLIC_URL + partner.logo}
                    alt={partner.name}
                    className="max-h-[64px] max-w-full object-contain"
                  />
                </div>
                <p className="text-[12px] font-[600] text-[#6B7280] text-center">
                  {partner.name}
                </p>
              </div>
            );
            return partner.url ? (
              <a key={partner.name} href={partner.url} target="_blank" rel="noopener noreferrer">
                {card}
              </a>
            ) : (
              <div key={partner.name}>{card}</div>
            );
          })}
        </div>

        <div className="flex justify-center">
          <Link
            to="/partnerships"
            className="text-[#1167D0] text-[14px] font-[600] hover:underline"
          >
            Learn more about our partnerships →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Partners;
